import React, { useEffect } from 'react'
import { Box, makeStyles } from '@material-ui/core'
import VoucherForm from '../../components/VoucherForm'
import ReactGA from 'react-ga' // certifique-se que ReactGA foi importado corretamente

const useStyles = makeStyles((theme) => ({
  page: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: '#E5E5E5',
    padding: theme.spacing(2),
    boxSizing: 'border-box',
  },
  aviso: {
    backgroundColor: '#FFD100',
    color: '#0045b5',
    padding: '20px',
    borderRadius: '8px',
    textAlign: 'center',
    maxWidth: '500px',
    margin: '20px',
    fontSize: '1.2em',
    'a ': {
      color: '#0045b5',
      textDecoration: 'underline',
    },
  },
}))

export default function VoucherPage() {
  const hostname = window.location.hostname

  useEffect(() => {
    document.title = 'Voucher'

    ReactGA.event({
      category: 'Voucher Form',
      action: 'Page Viewed'
    })
  }, [])

  const classes = useStyles()

  return (
    <Box className={classes.page}>
      {hostname === 'parceiroskmv.com.br' ?
        <VoucherForm /> :
        <div className={classes.aviso}>
          Seu acesso mudou! Clique no novo endereço: <a href="https://parceiroskmv.com.br/voucher">https://parceiroskmv.com.br/voucher</a>
        </div>}
    </Box >
  )
}
